import { render, staticRenderFns } from "./RightArrowIcon.vue?vue&type=template&id=41b45838"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b45838')) {
      api.createRecord('41b45838', component.options)
    } else {
      api.reload('41b45838', component.options)
    }
    module.hot.accept("./RightArrowIcon.vue?vue&type=template&id=41b45838", function () {
      api.rerender('41b45838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/RightArrowIcon.vue"
export default component.exports